import { AfterViewChecked, Component, EventEmitter, Input, Output, computed, input, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WebSearchSelectionCriterionDataForm } from '@r1-compass-library/models/criteria/selection-criteria-form.model';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faMagnifyingGlass, faTrash, faCalendar } from '@fortawesome/pro-solid-svg-icons';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { MatInputModule } from '@angular/material/input';
import { TypeaheadSearchComponent, TypeaheadSearchResult } from '@r1-compass-library/components';
import { DataMartService } from '@r1-compass-library/services';

@Component({
    selector: 'r1-compass-app-web-search-criterion',
    imports: [
        TypeaheadSearchComponent,
        FontAwesomeModule,
        FormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        ReactiveFormsModule,
    ],
    templateUrl: './web-search-criterion.component.html',
    styleUrl: './web-search-criterion.component.scss',
})
export class WebSearchCriterionComponent implements AfterViewChecked {
    readonly #dataMartService = inject(DataMartService);

    @Input()
    criterionForm: FormGroup<WebSearchSelectionCriterionDataForm> = new FormGroup(
        new WebSearchSelectionCriterionDataForm()
    );

    readonly deletable = input<boolean>(true);

    readonly displayOnly = input<boolean>(false);

    readonly displayIndex = input<boolean>(true);

    required = input.required<boolean>();

    index = input.required<number>();

    tabClass = computed(() => (this.required() ? 'criterion-index-tab required-row-tab' : 'criterion-index-tab'));

    @Output()
    deleteCriterion: EventEmitter<number> = new EventEmitter<number>();

    typeaheadResults: TypeaheadSearchResult[] = [];

    faTrash = faTrash;
    faCalendar = faCalendar;
    faMagnifyingGlass = faMagnifyingGlass;

    type = 'Web Search';

    constructor() {
        const library = inject(FaIconLibrary);

        library.addIcons(faTrash, faCalendar);
    }

    ngAfterViewChecked() {
        if (this.displayOnly()) {
            this.criterionForm.disable();
        }
    }

    onDelete() {
        this.deleteCriterion.emit(this.index());
    }
    onValueTypeahead(search: string) {
        this.#dataMartService.webSearch(search).subscribe(res => {
            this.typeaheadResults = res.entries.map(entry => {
                return {
                    display: entry,
                    value: entry,
                };
            });
        });
    }

    onDateInput(event: MatDatepickerInputEvent<Date>, formControl: FormControl<string | null>) {
        const isoString = event.value?.toISOString() ?? null;
        formControl.setValue(isoString);
    }
}
